module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-300.235b530c.ttf";